'use client';

import { imageLoader } from '@/shared/utils/image-loader';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { useModalContext } from '@/shared/components/overlay/use-modal-context';
import { useEffect } from 'react';

export const PlayGameOverlay = () => {
  const t = useTranslations('GamePage.playGameOverlay');
  const { setHeader } = useModalContext();

  useEffect(() => {
    setHeader(
      <h1 className='font-sans-bold flex-1 px-4 text-center text-xl'>{t('downloadStarted')}</h1>,
    );
  }, [setHeader, t]);

  return (
    <div className='mb-4 flex items-start justify-around gap-4'>
      <div className='flex flex-col items-center'>
        <div className='relative h-[180px] w-[180px]'>
          <Image
            src='/img/chrome_download.webp'
            loader={imageLoader}
            alt={t('chromeDownloadAltText')}
            fill
            sizes='180px'
            style={{ objectFit: 'contain' }}
          />
        </div>
        <p className='mt-2 text-center'>{t('openFile')}</p>
      </div>

      <div className='flex flex-col items-center'>
        <div className='relative h-[180px] w-[180px]'>
          <Image
            src='/img/uac_prompt.webp'
            loader={imageLoader}
            alt={t('uacPromptAltText')}
            fill
            sizes='180px'
            style={{ objectFit: 'contain' }}
          />
        </div>
        <p className='mt-2 text-center'>{t('installClient')}</p>
      </div>
    </div>
  );
};
